import { useParams } from 'react-router-dom';
import { useGetBookingQuery } from 'drycut-graphql';
import { BookingDetails } from 'booking/components';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';
import BookingPubSubWrapper from '../BookingPubSubWrapper';
import { useEffect } from 'react';
import { useGtagEvent } from '../hooks';

export function BookingDetailsByUid(): JSX.Element {
  useDocumentTitle('DRYCUT - Booking details');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useGetBookingQuery({ variables: { uid } });
  const { sendEvent } = useGtagEvent();

  // Send conversion event to Google
  useEffect(() => {
    sendEvent('conversion', {
      send_to: 'AW-866373683/nrFyCJqU6cQaELOgj50D',
    });
  }, [sendEvent]);

  if (loading) {
    return <Loader />;
  }

  const booking = data?.booking;

  return (
    <BookingPubSubWrapper uid={uid}>
      <BookingDetails booking={booking} />
    </BookingPubSubWrapper>
  );
}
